export default __webpack_public_path__ + "static/media/header-menu-planet-texture.38dbf806.png";